import { sendAppSession } from '@ui/utils/ActivityManager/httpRequest';

type SendStrategy<T extends any> = (payload: T, onResponse: (r: any) => void) => void | Promise<void>;

export class Transport<T extends any> {
  sendStrategy: SendStrategy<T>;

  constructor({ sendStrategy }: { sendStrategy: SendStrategy<T> }) {
    this.sendStrategy = sendStrategy;
  }

  send(data: T) {
    // promise를 반환해야 Storage.drain의 실패 복구(재큐)가 네트워크 오류를 잡을 수 있다
    return this.sendStrategy(data, (response) => {});
  }

  // 임시
  sendAppSession<K extends any>(data: K) {
    return sendAppSession(data);
  }
}
